import { i18n } from '@/localization/i18n';
import { showWarningToast } from './toastMessage';
// eslint-disable-next-line boundaries/element-types
import { store } from '@/app/store';

export const isAppOnline = () => {
   const status = store.getState().navigationData?.appOnlineStatus;
   const { isOnline = true, isConnectionActive = true } = status || {};
   return navigator.onLine && isOnline && isConnectionActive;
};

export const blockOfflineAction = ({ msg = '', showToast = true } = {}) => {
   if (!isAppOnline()) {
      if (showToast) {
         const defaultMsg = i18n.t('common.INTERNET_ERROR_MESSAGE');
         showWarningToast(msg || defaultMsg, { toastId: 'offline-toast' });
      }
      return true;
   }
   return false;
};
